module.exports = __webpack_public_path__ + "img/179985.9babded6.png";